import { get, post, put, del } from "@/utils/api";

export const AccountAPI = {
    list: async () => {
        return await get("/account/all");
    },
    get: async (accountId) => {
        return await get(`/account/${accountId}`);
    },
    getByName: async (name) => {
        return await get("/account", { name: name });
    },
    actives: async (params) => {
        const requestParams = { status: 1, accountType: params?.type, category: params?.category };
        return await get("/account/query", requestParams);
    },
    add: async (params) => {
        return await put("/account", params);
    },
    update: async (id, params) => {
        return await post(`/account/${id}`, params);
    },
    close: async (id) => {
        return await post(`/account/${id}/close`);
    },
    open: async (id) => {
        return await post(`/account/${id}/open`);
    }
};

export const TransactionAPI = {
    query: async (page, params) => {
        const criteria = { page: page, ...params };
        return await get("/transaction", criteria);
    },
    get: async (id) => {
        return await get(`/transaction/${id}`);
    },
    add: async (values) => {
        return await put("/transaction", values);
    },
    update: async (id, params) => {
        await post(`/transaction/${id}`, params);
    },
    updateCategory: async (id, params) => {
        await post(`/transaction/${id}/category`, params);
    },
    review: async (id) => {
        await post(`/transaction/${id}/reviewed`);
    },
    unreview: async (id) => {
        await post(`/transaction/${id}/unreviewed`);
    },
    delete: async (id) => {
        await del(`/transaction/${id}`);
    },
    addReceipt: async (params) => {
        return await put("/transaction/receipt", params);
    },
    deleteReceipt: async (tid, rid) => {
        return await del(`/transaction/${tid}/receipt/${rid}`);
    },
    downloadReceipt: async (docId) => {

    },
    relatedTransactions: async (transactionId) => {
        return await get(`/transaction/${transactionId}/related-transactions`);
    }
}

export const JournalAPI = {
    query: async (page, params) => {
        const criteria = { page: page, ...params };
        return await get("/journal", criteria);
    },
    details: async (page, params) => {
        const criteria = { page: page, ...params };
        return await get("/journal/details", criteria);
    },
    get: async (id) => {
        return await get(`/journal/${id}`);
    },
    add: async (values) => {
        return await put("/journal", values);
    },
    update: async (id, params) => {
        await post(`/journal/${id}`, params);
    },
    del: async (id) => {
        await del(`/journal/${id}`);
    }
}

export const GLAPI = {
    query: async (page, type, from, params) => {
        const criteria = { page: page, type: type, from: from, ...params };
        return await get("/gl", criteria);
    }
}
